import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import Basket from './Reducers/BaskitReducers';
import User from './Reducers/UserReduse';
import Order from './Reducers/OrderReducer';
const ConfigureStore = () => {
  const store = createStore(
    combineReducers({
      Basket,
      User,
      Order,
    }),
    applyMiddleware(thunk, logger)
  );

  //   const persistor = persistStore(store);
  console.log(store.getState());
  return store;
  // console.log();
};

export default ConfigureStore;
